<template>
  <header class="navbar">
    <div class="container-fluid">
      <button class="navbar-toggler mobile-toggler hidden-lg-up" type="button" @click="mainFull('mobile-open')">☰</button>
      <router-link :to="{name: 'Home'}" class="navbar-brand" style="background-image: url(/static/assets/img/logo.png);"></router-link>
      <ul class="nav navbar-nav hidden-md-down">
        <li class="nav-item">
          <a class="nav-link navbar-toggler layout-toggler" href="javascript:;" style="cursor: pointer" @click="mainFull('sidebar-nav')">☰</a>
        </li>
      </ul>
      <ul class="nav navbar-nav pull-xs-right hidden-xs-down">
        <li class="nav-item px-1">
          <span data-toggle="tooltip" v-html="t.user.hello.replace('%name%', session.username)" data-placement="left" title="Server time: 11.01.2021 11:28:37">
          </span>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {session: session, clock: '', t: this.$root.t}
  },
  mounted () {
  },
  methods: {
    mainFull(cls) {
      var body = document.body;
      var list = new Array(body.classList);
      if(Object.values(list[0]).includes(cls)) {
        body.classList.remove(cls)
      }else {
        body.classList.add(cls)
      }
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue